import { createReducer } from '@reduxjs/toolkit';

import { OrderDetailedStateType } from '../../types';
import {
  fetchIdOrder,
  fetchRealizationStatuses,
  setFilter,
  setOrderDetailedLoading,
  setSort,
} from '../actions/order-detailed';

const initialState: OrderDetailedStateType = {
  data: {},
  loading: {
    order: false,
    statuses: false,
  },
  filters: {
    status: 'ALL',
    search: '',
  },
  sorts: {
    positions: {
      direction: 'ASC',
      active: false,
    },
    count: {
      direction: 'ASC',
      active: false,
    },
    sum: {
      direction: 'ASC',
      active: false,
    },
  },
  statuses: [],
};

const orderDetailedReducer = createReducer(initialState, (builder) => {
  builder.addCase(setOrderDetailedLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(fetchIdOrder.fulfilled, (state, action) => {
    state.data.order = action.payload;
  });

  builder.addCase(fetchRealizationStatuses.fulfilled, (state, action) => {
    state.statuses = action.payload;
  });

  builder.addCase(setFilter, (state, action) => {
    state.filters[action.payload.type] = action.payload.value;
  });

  builder.addCase(setSort, (state, action) => {
    state.sorts[action.payload.name].direction = action.payload.direction;
    state.sorts[action.payload.name].active = true;

    if (action.payload.name === 'positions') {
      state.sorts.count = {
        direction: 'ASC',
        active: false,
      };
      state.sorts.sum = {
        direction: 'ASC',
        active: false,
      };
    }
    if (action.payload.name === 'count') {
      state.sorts.positions = {
        direction: 'ASC',
        active: false,
      };
      state.sorts.sum = {
        direction: 'ASC',
        active: false,
      };
    }
    if (action.payload.name === 'sum') {
      state.sorts.count = {
        direction: 'ASC',
        active: false,
      };
      state.sorts.positions = {
        direction: 'ASC',
        active: false,
      };
    }
  });
});

export default orderDetailedReducer;
